import React, { useCallback, useMemo, useState } from "react";

import PropTypes from "prop-types";

const DrawerContext = React.createContext();

export const DrawerContextProvider = (props) => {
    const [displaySearch, setDisplaySearch] = useState(true);
    const [show, setShow] = useState(false);
    const [isCTAPrimaryAction, setIsCTAPrimaryAction] = useState(true);

    const handleCloseMasterDrawer = useCallback(() => {
        setShow(false);
        setDisplaySearch(true);
        setIsCTAPrimaryAction(true);
    }, []);

    const handleSearchEmployeeClick = useCallback(() => {
        setShow(true);
    }, []);

    const contextValue = useMemo(() => {
        return {
            show,
            setShow,
            displaySearch,
            setDisplaySearch,
            isCTAPrimaryAction,
            setIsCTAPrimaryAction,
            handleCloseMasterDrawer,
            handleSearchEmployeeClick,
        };
    }, [
        show,
        setShow,
        displaySearch,
        setDisplaySearch,
        isCTAPrimaryAction,
        setIsCTAPrimaryAction,
        handleCloseMasterDrawer,
        handleSearchEmployeeClick,
    ]);

    return (
        <DrawerContext.Provider value={contextValue}>
            {props.children}
        </DrawerContext.Provider>
    );
};

DrawerContextProvider.propTypes = {
    children: PropTypes.node,
};

export default DrawerContext;
